import { jsx as _jsx } from "react/jsx-runtime";
import { useHardFacts } from "@/contexts/classified";
import { useMediumLink, useMortgage } from "@/hooks";
import { useBrandContext } from "@/shared/contexts";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { PARTNER_NAME } from "@/shared/types";
import { Box } from "@gemini/core";
import { Link } from "@gemini/ui";
export const PriceLink = ({ handleLinkClick }) => {
    var _a, _b, _c;
    const mortgage = useMortgage();
    const isPreviewMode = useIsPreviewMode();
    const partnerName = PARTNER_NAME.SCHUFA;
    const { financialLink } = ((_a = useHardFacts()) === null || _a === void 0 ? void 0 : _a.price) || {};
    const partner = ((_c = (_b = useBrandContext()) === null || _b === void 0 ? void 0 : _b.partnerService) !== null && _c !== void 0 ? _c : []).find((service) => service.name === partnerName);
    const mediumLink = useMediumLink("schufaRentLink");
    const priceLabel = mortgage === null || mortgage === void 0 ? void 0 : mortgage.priceLinkLabel;
    if (!priceLabel)
        return null;
    const isBuyPrice = mortgage === null || mortgage === void 0 ? void 0 : mortgage.showMonthlyRateLabel;
    const isRentPrice = !isBuyPrice && (mortgage === null || mortgage === void 0 ? void 0 : mortgage.showRentLabel);
    return isRentPrice && !(partner === null || partner === void 0 ? void 0 : partner.withObfuscation) ? (_jsx(Box, { as: "a", target: "_blank", cursor: "pointer", display: "flex", color: "inherit", onClick: handleLinkClick, "data-tracking": mediumLink, 
        // @ts-ignore
        href: mortgage.hasRentFinancialLink ? financialLink === null || financialLink === void 0 ? void 0 : financialLink.href : partner === null || partner === void 0 ? void 0 : partner.url, marginRight: "spacing.12", typography: "typography.body.16.regularUnderlined", children: _jsx(Box, { as: "span", typography: "typography.body.16.regularUnderlined", children: priceLabel }) })) : (_jsx(Link, { href: "#" + priceLabel, onPress: handleLinkClick, isDisabled: isPreviewMode, marginRight: "spacing.12", children: priceLabel }));
};
